<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-03-12 13:06:05
 * @LastEditTime : 2024-05-10 11:53:37
 * @LastEditors  : yangxr
 * @Description  : 生产运输
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\productTransport.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav" class="search">
              <span v-for="(item, index) in stationList" :key="index">
                <el-button size="medium" class="bottom_all_two" style="margin-left: 24px; margin-top: 24px" @click="goOutside(item)">{{ item.name }}</el-button>
              </span>
            </div>
          </el-collapse-transition>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
  
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { getUserInfo } from "@/utils/auth.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      stationList: [],
      stationId: "",
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.stationList = await getUserAutList(true);
    if (this.UserInfo.pointIds[0]) {
      this.stationId = this.UserInfo.pointIds[0];
    } else {
      this.stationId = this.stationList[0]?.id;
    }
  },
  methods: {
    goOutside(item) {
      window.sessionStorage.setItem("stationUserInfo", JSON.stringify({ UserInfo: this.UserInfo, stationInfo: item }));
      window.open("/#/productTransport_outside", "_blank");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
  